import * as React from 'react';
import { ReactNode } from 'react';
import * as Sentry from "@sentry/react";

interface Props {
  children: ReactNode;
}

const ErrorFallback = ({ error, resetError }: { error: Error; resetError: () => void }) => {
  let errorMessage = "Something went wrong.";
  
  try {
    // Check if it's a Firestore permission error (JSON string)
    const parsed = JSON.parse(error?.message || '');
    if (parsed.error && parsed.error.includes('Missing or insufficient permissions')) {
      errorMessage = "Oracle Access Denied. Please sign in to continue.";
    }
  } catch (e) {
    // Not a JSON error, use default
  }

  return (
    <div className="min-h-screen bg-[#1c1c1c] text-white flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-[#2a2a2a] p-8 rounded-3xl border border-white/5 text-center">
        <h2 className="text-2xl font-bold mb-4">🔮 The Oracle is Silent</h2>
        <p className="text-gray-400 mb-6">{errorMessage}</p>
        <button
          onClick={() => {
            resetError();
            window.location.reload();
          }}
          className="w-full bg-[#ff0080] text-white py-3 rounded-full font-bold hover:bg-[#ff0080]/80 transition-colors"
        >
          Try Again
        </button>
      </div>
    </div>
  );
};

export const ErrorBoundary = ({ children }: Props) => {
  return (
    <Sentry.ErrorBoundary fallback={ErrorFallback}>
      {children}
    </Sentry.ErrorBoundary>
  );
};
